import { AlertDeliveryChannel, AlertDeliveryStatus, AlertEventState, AlertSeverityLevel } from '../enums/alert.enum';
import { NotificationAveragingEnum } from '../enums/notificationAveraging.enum';
import { NotificationConditionType } from '../enums/notificationConditionType.enum';
import { ParameterTypeEnum } from '../enums/parameterType.enum';

export { AlertDeliveryChannel, AlertDeliveryStatus, AlertEventState, AlertSeverityLevel };

export interface AlertDeliveryLog {
    recipientName?: string;
    recipientEmail?: string;
    recipientDisplayName?: string;
    userId?: string;
    channel: AlertDeliveryChannel | string | number;
    status: AlertDeliveryStatus | string | number;
    attemptedAt?: Date | string | number;
    displayStatusLabel?: string;
    displayChannelLabel?: string;
    sentAt?: Date | string | number;
    displayDate?: Date | string | number;
    deliveredAt?: Date | string | number;
    openedAt?: Date | string | number;
    failureReason?: string;
}

export interface AlertStateTransition {
    id?: string;
    alertEventId?: string;
    fromState?: AlertEventState | string;
    toState: AlertEventState | string;
    transitionedAt?: Date | string | number;
    transitionedByUserId?: string;
    transitionedByUserName?: string;
    source?: number;
    comment?: string;
    displayToStateLabel?: string;
}

export interface AlertEventTransitionResponse {
    id?: string;
    alertEventId?: string;
    nodeName?: string;
    fromState?: AlertEventState | string | number;
    toState?: AlertEventState | string | number;
    transitionedAt?: Date | string | number;
    transitionedByUserId?: string;
    transitionedByUserName?: string;
    source?: number;
    comment?: string;
}

export interface AlertEventResponse {
    id: string;
    notificationName?: string;
    sensorId: string;
    parameterId?: string | null;
    organizationLevelId?: string | null;
    siteId?: string | null;
    siteName?: string;
    parameterName?: string;
    endPointId?: string | null;
    customEntityId?: string | null;
    notificationSettingsId: string;
    ruleVersion: number;
    severity: number;
    state: number;
    startedAt: Date | string;
    peakAt: Date | string;
    peakValue: number;
    endedAt?: Date | string | null;
    stateUpdatedAt?: Date | string | null;
    deliveryStatus?: AlertDeliveryStatus | string | number;
    deliveryLogs?: AlertDeliveryLog[];
    transitions?: AlertStateTransition[];
    stateTransitions?: AlertStateTransition[];
    stateTransitionsLoaded?: boolean;
    isLoadingStateTransitions?: boolean;
    isSuppressed?: boolean;
    suppressionReason?: string;
    dateCreated: Date | string;
    dateUpdated: Date | string;
}

export class AppNotification {
    id: string;
    notificationName: string;
    notificationSentDate: Date | number;
    sentDate: Date | string;
    shiftStartDate: Date;
    parameterType: ParameterTypeEnum;
    parameterId: string;
    parameterName: string;
    averagingType: NotificationAveragingEnum;
    value: number;
    conditionType: NotificationConditionType;
    timePeriod: number;
    sensor: string;
    endPoint: string;
    sensorId: string;
    endPointId: string;
    organizationLevelId: string;
    siteId?: string;
    startedAt?: Date | string;
    peakAt?: Date | string;
    peakValue?: number;
    endedAt?: Date | string | null;
    severity?: AlertSeverityLevel | number;
    state?: AlertEventState;
    siteName?: string;
    stateUpdatedAt?: Date | string | number;
    deliveryStatus?: AlertDeliveryStatus | string | number;
    deliveryStatusLabel?: string;
    acknowledgedAt?: Date | string | number;
    resolvedAt?: Date | string | number;
    escalatedAt?: Date | string | number;
    deliveryLogs?: AlertDeliveryLog[];
    stateTransitions?: AlertStateTransition[];
    stateTransitionsLoaded?: boolean;
    isLoadingStateTransitions?: boolean;
    isSuppressed?: boolean;
    suppressionReason?: string;
    alertDate?: Date | number | string;
    effectiveState?: AlertEventState;
    stateLabel?: string;
    stateBadgeClass?: string;
    siteDisplayName?: string;
    parameterDisplayName?: string;
    deliverySummary?: string;
    isExpanded?: boolean;
    deliveryLogsLoaded?: boolean;
    isLoadingDeliveryLogs?: boolean;
    deliveryLogsLoadError?: boolean;
    isUpdatingState?: boolean;
}
export class FilteredNotificationPayload {
    nodeId: string;
    startDate: number;
    endDate: number;
    analyteId: string;
    organizationLevelId?: string;
}
